<template>
  <div id="app" class="purchase-history-container">
    <!-- 页面头部 -->
    <div class="page-header">
      <h2 class="page-title">西药其他入库</h2>
      <div class="header-actions">
        <!-- <el-button 
          type="text" 
          size="small" 
          icon="el-icon-adds"
          @click="handleAddNew"
        >新增</el-button>
        <el-button 
          type="text" 
          size="small" 
          icon="el-icon-del"
          @click="handleDelete"
        >删除</el-button>
        <el-button type="text" size="small" icon="el-icon-upload2">智能导入</el-button>
        <el-button type="text" size="small" icon="el-icon-download">导出</el-button>
        <el-button type="text" size="small" icon="el-icon-refresh" @click="handleRefresh">刷新</el-button>
        <el-button
          type="text" 
          size="small" 
          icon="el-icon-setting"
          @click="showColumnSettings = true"
        >
          设置
        </el-button>
        
        <el-dropdown trigger="click">
          <el-button type="text" size="small" icon="el-icon-more">更多</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>打印</el-dropdown-item>
            <el-dropdown-item>导出模板</el-dropdown-item>
            <el-dropdown-item>批量操作</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-checkbox type="text" size="mini" style="color: #00557f;">显示明细</el-checkbox> -->
      </div>
    </div>

    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-form :inline="true" size="small" :model="filterForm">
        <el-form-item label="单据日期">
          <el-radio-group v-model="filterForm.dateRangeType" @change="handleDateRangeChange">
            <el-radio-button label="today">今天</el-radio-button>
            <el-radio-button label="yesterday">昨天</el-radio-button>
            <el-radio-button label="last7days">近7天</el-radio-button>
            <el-radio-button label="lastMonth">近1月</el-radio-button>
            <el-radio-button label="custom">自定义</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-if="filterForm.dateRangeType === 'custom'"
            v-model="filterForm.customDateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            style="margin-left: 10px; width: 240px;"
            @change="handleDateRangeChange"
          >
          </el-date-picker>
        </el-form-item>
        
        <el-form-item label="单据状态">
          <el-select v-model="filterForm.state" placeholder="请选择" size="small" @change="handleStateChange">
            <el-option label="全部" value=""></el-option>
            <el-option label="草稿" value="0"></el-option>
            <el-option label="已提交" value="2"></el-option>
            <el-option label="已审核" value="4"></el-option>
            <el-option label="已过单" value="5"></el-option>
            <el-option label="已冲销" value="6"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="单据编号">
          <el-input v-model="filterForm.documentNo" placeholder="请输入单据编号" size="small"></el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="text" @click="toggleMoreFilters">
            {{ showMoreFilters ? '收起' : '展开' }}更多条件
            <i :class="['el-icon-arrow-down', {'el-icon-arrow-up': showMoreFilters}]"></i>
          </el-button>
        </el-form-item>
        
        <el-form-item style="float: right;">
          <el-button type="primary" size="small" @click="handleQuery">查询</el-button>
          <el-button size="small" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      
      <!-- 更多筛选条件 -->
      <div v-show="showMoreFilters" class="more-filters">
        <el-form :inline="true" size="small" :model="filterForm">
          <el-form-item label="单据类型">
            <el-select v-model="filterForm.documentType" placeholder="请选择" size="small">
              <el-option label="全部" value=""></el-option>
              <el-option label="采购单" value="purchase"></el-option>
              <el-option label="退货单" value="return"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="供应商">
            <el-select v-model="filterForm.supplier" placeholder="请选择" size="small" filterable>
              <el-option label="全部" value=""></el-option>
              <el-option 
                v-for="item in supplierOptions" 
                :key="item.id" 
                :label="item.label" 
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="药库">
            <el-select v-model="filterForm.warehouse" placeholder="请选择" size="small">
              <!-- <el-option label="全部" value=""></el-option> -->
              <el-option label="西药库" value="main"></el-option>
              <el-option label="中药库" value="branch"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <!-- 表格区域 -->
    <div class="table-section" :style="{ height: tableHeight + 'px' }">
      <div class="table-container" :class="tableStyleClass">
        <el-table
          :data="tableData"
          :height="tableInnerHeight"
          border
          style="width: 100%"
          :row-style="{ height: rowHeight + 'px' }"
          :cell-style="{ padding: cellPadding + 'px' }"
          :header-cell-style="{ 
            'font-size': headerFontSize + 'px',
            'font-weight': 'bold',
            'background-color': '#f5f7fa'
          }"
          @current-change="handleCurrentTableChange"
          highlight-current-row
          ref="mainTable"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" label="#" width="60" align="center"></el-table-column>
          
          <!-- 展开行显示详细信息 -->
          <el-table-column type="expand" width="50" fixed="left" class-name="custom-expand-column">
            <template slot-scope="props">
              <div class="expand-content-wrapper" style="padding: 10px;">
                <el-descriptions class="margin-top" :column="4" border size="mini">
                  <el-descriptions-item label="单据编号">{{ props.row.docNum }}</el-descriptions-item>
                  <el-descriptions-item label="业务日期">{{ props.row.busDate }}</el-descriptions-item>
                  <el-descriptions-item label="供货单位">{{ props.row.supplierName }}</el-descriptions-item>
                  <el-descriptions-item label="申请人">{{ props.row.createName }}</el-descriptions-item>
                  <el-descriptions-item label="制单时间">{{ props.row.createTime }}</el-descriptions-item>
                  <el-descriptions-item label="合计金额">{{ props.row.totalAmt }}</el-descriptions-item>
                  <el-descriptions-item label="审核人">{{ props.row.reviewName }}</el-descriptions-item>
                  <el-descriptions-item label="审核时间">{{ props.row.reviewTime }}</el-descriptions-item>
                </el-descriptions>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column 
            v-for="column in visibleColumns" 
            :key="column.prop"
            :prop="column.prop" 
            :label="column.label"
            :width="column.width"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <!-- 状态列特殊处理 -->
              <template v-if="column.prop === 'state'">
                <div class="stateValue clickable" :style="getStatusStyle(scope.row.state)" @click="handleStatusClick(scope.row)">
                  <i :class="getStatusIcon(scope.row.state)"></i>
                  <span>{{ getStatusText(scope.row.state) }}</span>
                </div>
              </template>
              <template v-else>
                <span>{{ scope.row[column.prop] }}</span>
              </template>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleView(scope.row)">查看</el-button>
              <el-button 
                type="text" 
                size="mini" 
                @click="handleEdit(scope.row)"
                v-if="scope.row.state === 0"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-section">
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
	<!-- 列设置模态框 -->
	    <el-dialog 
	      title="列设置" 
	      :visible.sync="showColumnSettings" 
	      width="600px"
	      :before-close="handleCloseDialog"
	    >
	      <div class="column-settings">
	        <el-tabs v-model="activeTab">
	          <el-tab-pane label="表格字体行高设置" name="fontSettings">
	            <div class="setting-item">
	              <h4>字体大小设置</h4>
	              <el-radio-group v-model="fontSize" @change="updateTableStyle">
	                <el-radio label="small">默认字号</el-radio>
	                <el-radio label="medium">较大字号</el-radio>
	                <el-radio label="large">特大字号</el-radio>
	              </el-radio-group>
	            </div>
	            
	            <div class="setting-item">
	              <h4>表格高度设置</h4>
	              <el-radio-group v-model="rowHeightType" @change="updateTableStyle">
	                <el-radio label="compact">紧凑行高</el-radio>
	                <el-radio label="normal">适中行高</el-radio>
	                <el-radio label="loose">宽松行高</el-radio>
	              </el-radio-group>
	            </div>
	            
	            <div class="setting-hint">
	              <i class="el-icon-info"></i>
	              <span>此设置会应用于所有单据、账簿、报表等页面的表格中</span>
	            </div>
	          </el-tab-pane>
	          
	          <el-tab-pane label="列显示设置" name="columnSettings">
	            <div class="column-list">
	              <el-checkbox-group v-model="selectedColumns">
	                <el-checkbox 
	                  v-for="column in allColumns" 
	                  :key="column.prop" 
	                  :label="column.prop"
	                >
	                  {{ column.label }}
	                </el-checkbox>
	              </el-checkbox-group>
	            </div>
	          </el-tab-pane>
	        </el-tabs>
	      </div>
	      
	      <div slot="footer" class="dialog-footer">
	        <el-button @click="handleCloseDialog">取消</el-button>
	        <el-button type="primary" @click="handleSaveSettings">确定</el-button>
	      </div>
	    </el-dialog>
    <!-- 详情模态框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="detailDialogVisible" 
      width="85%" 
      :before-close="handleDetailClose"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      class="detail-dialog"
    >
      <div class="detail-container">
        <!-- 表单区域 -->
        <div class="form-section">
          <el-form ref="detailForm" :model="detailForm" label-width="100px" size="mini" :inline="true">
            <el-row :gutter="20">
              <el-col :span="8" v-for="(field, index) in formFields" :key="index">
                <el-form-item :label="field.label" v-if="field.visible !== false">
                  <el-input 
                    v-if="field.type === 'input'"
                    v-model="detailForm[field.prop]"
                    :placeholder="field.placeholder"
                    :disabled="field.disabled"
                    size="mini"
                  ></el-input>
                  <el-select 
                    v-if="field.type === 'select'"
                    v-model="detailForm[field.prop]"
                    :disabled="field.disabled"
                    filterable
                    placeholder="请选择"
                    style="width: 100%"
                  >
                    <el-option 
                      v-for="option in getOptions(field.optionsKey)"
                      :key="option.id"
                      :label="option.label"
                      :value="option.id"
                    ></el-option>
                  </el-select>
                  <el-date-picker
                    v-if="field.type === 'date'"
                    v-model="detailForm[field.prop]"
                    type="date"
                    placeholder="选择日期"
                    style="width: 100%"
                    :disabled="field.disabled"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="detail-table-section">
          <el-table
            :data="detailTableData"
            border
            style="width: 100%"
            size="mini"
          >
            <el-table-column 
              v-for="column in detailTableColumns" 
              :key="column.prop"
              :prop="column.prop" 
              :label="column.label"
              :width="column.width"
              align="center"
            >
            </el-table-column>
          </el-table>
          
          <!-- 合计金额 -->
          <div class="total-section">
            <span>成本合计金额：</span>
            <el-input 
              :value="costTotal | currencyFormat" 
              style="width: 150px; margin-right: 20px;" 
              size="mini" 
              disabled
            ></el-input>
            <span>零售合计金额：</span>
            <el-input 
              :value="saleTotal | currencyFormat" 
              style="width: 150px;" 
              size="mini" 
              disabled
            ></el-input>
          </div>
        </div>
      </div>
      
      <!-- 底部按钮区域 -->
      <div slot="footer" class="dialog-footer">
        <!-- 查看模式 -->
        <template v-if="currentDetailMode === 'view'">
          <el-button size="mini" @click="detailDialogVisible = false">关闭</el-button>
        </template>
        
        <!-- 草稿模式 -->
        <template v-else-if="currentDetailMode === 'draft'">
          <el-button size="mini" type="primary" @click="handleSubmit">提交审核</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 审核模式 -->
        <template v-else-if="currentDetailMode === 'examine'">
          <el-button size="mini" type="danger" @click="handleRefuseExamine">拒绝审核</el-button>
          <el-button size="mini" type="primary" @click="handleExamineSubmit">确认审核</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 过单模式 -->
        <template v-else-if="currentDetailMode === 'pass'">
          <el-button size="mini" type="danger" @click="handleRefusePass">拒绝过单</el-button>
          <el-button size="mini" type="primary" @click="handlePassSubmit">确认过单</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
        
        <!-- 冲销模式 -->
        <template v-else-if="currentDetailMode === 'reverse'">
          <el-button size="mini" type="danger" @click="handleReverse">确认冲销</el-button>
          <el-button size="mini" @click="detailDialogVisible = false">取消</el-button>
        </template>
      </div>
    </el-dialog>

    <!-- 操作进度模态框 -->
    <el-dialog
      title="操作执行中..."
      :visible.sync="operationModalVisible"
      width="40%"
      :close-on-click-modal="false"
      :show-close="false"
      :close-on-press-escape="false"
    >
      <div class="operation-progress-container">
        <div class="status-messages">
          <div v-for="(step, index) in operationSteps" :key="index" class="status-item">
            <span>{{ step.text }}</span>
            <span class="status-icon">
              <i v-if="step.status === 'success'" class="el-icon-success" style="color: #67C23A"></i>
              <i v-else-if="step.status === 'error'" class="el-icon-error" style="color: #F56C6C"></i>
              <i v-else class="el-icon-loading" style="color: #409EFF"></i>
            </span>
          </div>
        </div>

        <el-progress
          :percentage="operationProgress"
          :stroke-width="12"
          style="margin-top: 20px;"
        ></el-progress>

        <div class="step-messages" v-if="operationStepMessages.length > 0">
          <div v-for="(msg, index) in operationStepMessages" :key="index" 
               :class="['step-message', msg.class]">
            <span class="time">[{{ msg.time }}]</span>
            <span>{{ msg.text }}</span>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 新增/编辑页面 -->
    <transition name="el-zoom-in-center">
      <div v-if="showAddPage" class="add-page-container">
        <AddRet 
          ref="addRetRef"
          :current-row="currentTable"
          :mode="currentMode"
          @close="handleCloseAddPage"
          @refresh="handleRefresh"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import AddRet from './AddRet.vue'
import { getXYOther, getRetnDetail, toRetnExamine, deleteReturn, selectDropDownList } from "@/api/PSI/shopReturn.js";
import dayjs from "dayjs";

// 千位分隔符过滤器
const currencyFormat = (value) => {
  if (value === null || value === undefined) return '0.00';
  const num = Number(value);
  if (isNaN(num)) return '0.00';
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

export default {
  name: 'PurchaseHistory',
  components: {
    AddRet
  },
  filters: {
    currencyFormat
  },
  data() {
    return {
      // 筛选表单
      filterForm: {
        dateRangeType: 'today',
        customDateRange: [],
        state: '',
        documentNo: '',
        documentType: '',
        supplier: '',
        warehouse: ''
      },
      showMoreFilters: false,
      
      // 供应商选项
      supplierOptions: [],
      
      // 表格数据
      tableData: [],
      
      // 表格列配置
      allColumns: [
        { prop: 'docNum', label: '单据编号', width: 168 },
        { prop: 'busDate', label: '业务日期', width: 120 },
        { prop: 'state', label: '状态', width: 100 },
        { prop: 'supplierName', label: '供货单位', width: 120 },
        { prop: 'costAmt', label: '成本金额', width: 100 },
        { prop: 'saleAmt', label: '销售金额', width: 100 },
        { prop: 'createName', label: '申请人', width: 100 },
        { prop: 'createTime', label: '制单时间', width: 120 },
        { prop: 'reviewName', label: '审核人', width: 100 },
        { prop: 'reviewTime', label: '审核时间', width: 120 },
        { prop: 'passingOrdersName', label: '过单人', width: 100 },
        { prop: 'passingOrdersTime', label: '过单时间', width: 120 }
      ],
      selectedColumns: [],
      
      // 分页
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      
      // 表格样式设置
      showColumnSettings: false,
      activeTab: 'fontSettings',
      fontSize: 'small',
      rowHeightType: 'normal',
      
      // 表格高度
      tableHeight: 400,
      tableInnerHeight: 400,
      
      // 新增页面控制
      showAddPage: false,
      currentTable: null,
      currentMode: 'add',
      
      // 详情模态框相关
      detailDialogVisible: false,
      dialogTitle: '',
      currentDetailMode: 'view',
      detailForm: {
        id: '',
        docNum: '',
        busDate: '',
        supplierId: '',
        supplierName: '',
        createName: '',
        totalAmt: '',
        state: ''
      },
      detailTableData: [],
      costTotal: 0,
      saleTotal: 0,
      
      // 表单字段配置
      formFields: [
        { prop: 'docNum', label: '单据编号', type: 'input', disabled: true },
        { prop: 'busDate', label: '业务日期', type: 'date', disabled: true },
        { prop: 'supplierId', label: '供应商', type: 'select', optionsKey: 'supplierOptions', disabled: true },
        { prop: 'createName', label: '制单人', type: 'input', disabled: true },
        { prop: 'reviewName', label: '审核人', type: 'input', disabled: true },
        { prop: 'totalAmt', label: '合计金额', type: 'input', disabled: true }
      ],
      
      // 详情表格列配置
      detailTableColumns: [
        { prop: 'drugCode', label: '药品编码', width: 120 },
        { prop: 'drugName', label: '药品名称', width: 150 },
        { prop: 'drugSpec', label: '规格描述', width: 120 },
        { prop: 'retnCnt', label: '退库数量', width: 100 },
        { prop: 'unt', label: '退库单位', width: 100 },
        { prop: 'retnPric', label: '成本单价', width: 100 },
        { prop: 'retnAmt', label: '成本金额', width: 100 },
        { prop: 'salePric', label: '零售单价', width: 100 },
        { prop: 'saleAmt', label: '零售金额', width: 100 },
        { prop: 'prodentpName', label: '生产厂家', width: 120 },
        { prop: 'manuLotnum', label: '生产批号', width: 120 }
      ],
      
      // 操作进度相关
      operationModalVisible: false,
      operationProgress: 0,
      operationSteps: [
        {text: '数据准备', status: ''},
        {text: '执行操作', status: ''},
        {text: '结果验证', status: ''}
      ],
      operationStepMessages: []
    }
  },
  computed: {
    // 可见列
    visibleColumns() {
      return this.allColumns.filter(col => this.selectedColumns.includes(col.prop));
    },
    
    // 表格样式类
    tableStyleClass() {
      return `font-${this.fontSize} row-${this.rowHeightType}`;
    },
    
    // 行高
    rowHeight() {
      const heightMap = {
        compact: 32,
        normal: 40,
        loose: 48
      };
      return heightMap[this.rowHeightType] || 40;
    },
    
    // 单元格内边距
    cellPadding() {
      const paddingMap = {
        compact: 4,
        normal: 8,
        loose: 12
      };
      return paddingMap[this.rowHeightType] || 8;
    },
    
    // 表头字体大小
    headerFontSize() {
      const sizeMap = {
        small: 12,
        medium: 14,
        large: 16
      };
      return sizeMap[this.fontSize] || 12;
    }
  },
  mounted() {
    // 初始化选中所有列
    this.selectedColumns = this.allColumns.map(col => col.prop);
    
    // 计算表格高度
    this.calculateTableHeight();
    window.addEventListener('resize', this.calculateTableHeight);
    
    // 加载数据
    this.loadData();
    
    // 获取供应商选项
    this.getSupplierOptions();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    // 获取供应商选项
    async getSupplierOptions() {
      try {
        const res = await selectDropDownList();
        if (res.code === 200) {
          this.supplierOptions = res.data.content.map(item => ({
            id: item.supplierId,
            label: item.supplierName,
            value: item.supplierId
          }));
        } else {
          console.error('获取供应商列表失败:', res.message);
          this.$message.error('获取供应商列表失败');
        }
      } catch (error) {
        console.error('获取供应商列表失败:', error);
        this.$message.error('获取供应商列表失败');
      }
    },
    
    // 加载数据
    async loadData() {
      try {
        // 构建日期参数
        let startDate = '';
        let endDate = '';
        
        const today = dayjs();
        switch(this.filterForm.dateRangeType) {
          case 'today':
            startDate = today.format('YYYY-MM-DD');
            endDate = today.format('YYYY-MM-DD');
            break;
          case 'yesterday':
            startDate = today.subtract(1, 'day').format('YYYY-MM-DD');
            endDate = today.subtract(1, 'day').format('YYYY-MM-DD');
            break;
          case 'last7days':
            startDate = today.subtract(7, 'day').format('YYYY-MM-DD');
            endDate = today.format('YYYY-MM-DD');
            break;
          case 'lastMonth':
            startDate = today.subtract(1, 'month').format('YYYY-MM-DD');
            endDate = today.format('YYYY-MM-DD');
            break;
          case 'custom':
            if (this.filterForm.customDateRange && this.filterForm.customDateRange.length === 2) {
              startDate = dayjs(this.filterForm.customDateRange[0]).format('YYYY-MM-DD');
              endDate = dayjs(this.filterForm.customDateRange[1]).format('YYYY-MM-DD');
            }
            break;
        }
        
        const params = {
          state: this.filterForm.state || '',
          startDate: startDate,
          endDate: endDate,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          docNum: this.filterForm.documentNo || '',
          supplierId: this.filterForm.supplier || ''
        };
        
        const res = await getXYOther(params);
        
        if (res.code === 200) {
          this.tableData = res.data.content || [];
          this.totalCount = res.data.totalSize || 0;
        } else {
          this.$message.error(res.message || '获取数据失败');
          this.tableData = [];
          this.totalCount = 0;
        }
      } catch (error) {
        console.error('加载数据失败:', error);
        this.$message.error('加载数据失败');
        this.tableData = [];
        this.totalCount = 0;
      }
    },
    
    // 计算表格高度
    calculateTableHeight() {
          const windowHeight = window.innerHeight;
          const headerHeight = 60;
          const filterHeight = this.showMoreFilters ? 180 : 100;
          const footerHeight = 40;
          const paginationHeight = 50;
          const margin = 20;
          
          this.tableHeight = windowHeight - headerHeight - filterHeight - footerHeight - paginationHeight - margin;
          this.tableInnerHeight = this.tableHeight - 10;
        },
        
        // 切换更多筛选条件
        toggleMoreFilters() {
          this.showMoreFilters = !this.showMoreFilters;
          this.calculateTableHeight();
        },
        
        // 处理日期范围变化
        handleDateRangeChange() {
          if (this.filterForm.dateRangeType !== 'custom') {
            this.filterForm.customDateRange = [];
          }
          // 立即调用接口
          this.currentPage = 1;
          this.loadData();
        },
        
        // 处理状态变化
        handleStateChange() {
          // 立即调用接口
          this.currentPage = 1;
          this.loadData();
        },
        
        // 查询
        handleQuery() {
          this.currentPage = 1;
          this.loadData();
        },
        
        // 重置
        handleReset() {
          this.filterForm = {
            dateRangeType: 'today',
            customDateRange: [],
            state: '',
            documentNo: '',
            documentType: '',
            supplier: '',
            warehouse: ''
          };
          this.currentPage = 1;
          this.loadData();
        },
        
        // 刷新
        handleRefresh() {
          this.loadData();
        },
        
        // 分页大小变化
        handleSizeChange(val) {
          this.pageSize = val;
          this.currentPage = 1;
          this.loadData();
        },
        
        // 当前页变化
        handleCurrentChange(val) {
          this.currentPage = val;
          this.loadData();
        },
        
        // 表格行选择变化
        handleCurrentTableChange(val) {
          this.currentTable = val;
        },
        
        // 查看
        handleView(row) {
          this.currentTable = row;
          this.currentMode = 'view';
          this.showAddPage = true;
        },
        
        // 编辑
        handleEdit(row) {
          if (row.state !== 0) {
            this.$message.warning('只有草稿状态的数据可以编辑');
            return;
          }
          this.currentTable = row;
          this.currentMode = 'edit';
          this.showAddPage = true;
        },
        
        // 新增
        handleAddNew() {
          this.currentTable = null;
          this.currentMode = 'add';
          this.showAddPage = true;
        },
        
        // 关闭新增页面
        handleCloseAddPage() {
          this.showAddPage = false;
          this.currentTable = null;
          this.currentMode = 'add';
        },
        
        // 状态相关方法
        getStatusText(state) {
          const statusMap = {
            0: '草稿',
            2: '已提交',
            4: '已审核',
            5: '已过单',
            6: '已冲销'
          };
          return statusMap[state] || '未知状态';
        },
        
        getStatusIcon(state) {
          const iconMap = {
            0: 'el-icon-document',
            2: 'el-icon-top-left',
            4: 'el-icon-check',
            5: 'el-icon-document-checked',
            6: 'el-icon-delete'
          };
          return iconMap[state] || 'el-icon-question';
        },
        
        getStatusStyle(state) {
          const colorMap = {
            0: { backgroundColor: '#e2fff6', color: '#004a00', cursor: 'pointer' },
            2: { backgroundColor: '#f0f9ff', color: '#00557f', cursor: 'pointer' },
            4: { backgroundColor: '#fdf6ec', color: '#b88230', cursor: 'pointer' },
            5: { backgroundColor: '#f0f9ff', color: '#00557f', cursor: 'pointer' },
            6: { backgroundColor: '#fef0f0', color: '#f56c6c', cursor: 'pointer' }
          };
          return colorMap[state] || { backgroundColor: '#f5f7fa', color: '#909399', cursor: 'pointer' };
        },
        
        // 根据状态获取对话框标题
        getDialogTitle(state, docNum) {
          const titleMap = {
            0: `提交${docNum}`,
            2: `审核${docNum}`,
            4: `过单${docNum}`,
            5: `冲销${docNum}`
          };
          return titleMap[state] || `查看${docNum}`;
        },
        
        // 点击状态标签
        async handleStatusClick(row) {
          try {
            console.log('点击状态标签，行数据:', row);
            
            // 根据状态设置模态框模式和标题
            this.currentDetailMode = this.getDetailModeByState(row.state);
            this.dialogTitle = this.getDialogTitle(row.state, row.docNum);
            
            // 加载详情数据
            const res = await getRetnDetail({ id: row.id });
            
            if (res.code === 200) {
              console.log('获取详情成功:', res.data);
              
              // 填充表单数据
              Object.keys(this.detailForm).forEach(key => {
                if (res.data[key] !== undefined) {
                  this.detailForm[key] = res.data[key];
                }
              });
              
              // 设置供应商ID和名称
              if (res.data.supplierId) {
                this.detailForm.supplierId = res.data.supplierId;
                // 查找供应商名称
                const supplier = this.supplierOptions.find(item => item.id === res.data.supplierId);
                if (supplier) {
                  this.detailForm.supplierName = supplier.label;
                }
              }
              
              // 填充表格数据
              this.detailTableData = res.data.list || [];
              
              // 计算合计金额
              this.costTotal = this.detailTableData.reduce((total, item) => {
                return total + (parseFloat(item.retnAmt) || 0);
              }, 0);
              
              this.saleTotal = this.detailTableData.reduce((total, item) => {
                return total + (parseFloat(item.saleAmt) || 0);
              }, 0);
              
              this.detailForm.id = row.id;
              this.detailForm.state = row.state;
              
              this.detailDialogVisible = true;
            } else {
              console.error('获取详情失败:', res.message);
              this.$message.error('获取详情失败: ' + (res.message || '未知错误'));
            }
          } catch (error) {
            console.error('加载详情失败:', error);
            this.$message.error('加载详情失败: ' + error.message);
          }
        },
        
        // 根据状态获取详情模态框模式
        getDetailModeByState(state) {
          const modeMap = {
            0: 'draft',      // 草稿 => 提交
            2: 'examine',    // 已提交 => 审核
            4: 'pass',       // 已审核 => 过单
            5: 'reverse'     // 已过单 => 冲销
          };
          return modeMap[state] || 'view';
        },
        
        // 删除功能
        async handleDelete() {
          // 检查是否选中了单据
          if (!this.currentTable) {
            this.$message.warning('请先选择一条单据！');
            return;
          }
          
          // 检查是否为草稿状态
          if (this.currentTable.state !== 0) {
            this.$message.warning('只有草稿状态的单据可以删除！');
            return;
          }
          
          try {
            // 确认删除
            await this.$confirm('确定要删除选中的单据吗？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
            
            // 调用删除接口
            const result = await deleteReturn({ id: this.currentTable.id });
            
            if (result.code === 200) {
              this.$message.success('删除成功');
              // 刷新数据
              this.loadData();
              // 清空当前选中
              this.currentTable = null;
              this.$refs.mainTable.setCurrentRow();
            } else {
              this.$message.error(result.message || '删除失败');
            }
          } catch (error) {
            if (error !== 'cancel') {
              console.error('删除失败:', error);
              this.$message.error('删除失败: ' + (error.message || '未知错误'));
            }
          }
        },
        
        // 提交审核
        async handleSubmit() {
          try {
            this.detailForm.state = 2; // 已提交
            const result = await toRetnExamine(this.detailForm);
            
            if (result.code === 200) {
              this.$message.success('提交成功');
              this.detailDialogVisible = false;
              this.loadData(); // 刷新表格
            } else {
              this.$message.error(result.message || '提交失败');
            }
          } catch (error) {
            console.error('提交失败:', error);
            this.$message.error('提交失败');
          }
        },
        
        // 通过审核
        async handleExamineSubmit() {
          try {
            this.detailForm.state = 4; // 已审核
            const result = await toRetnExamine(this.detailForm);
            
            if (result.code === 200) {
              this.$message.success('审核通过');
              this.detailDialogVisible = false;
              this.loadData(); // 刷新表格
            } else {
              this.$message.error(result.message || '审核失败');
            }
          } catch (error) {
            console.error('审核失败:', error);
            this.$message.error('审核失败');
          }
        },
        
        // 拒绝审核
        handleRefuseExamine() {
          this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            try {
              this.detailForm.state = 0; // 回退到草稿
              const result = await toRetnExamine(this.detailForm);
              
              if (result.code === 200) {
                this.$message.success('已回退到草稿状态');
                this.detailDialogVisible = false;
                this.loadData(); // 刷新表格
              } else {
                this.$message.error(result.message || '回退失败');
              }
            } catch (error) {
              console.error('回退失败:', error);
              this.$message.error('回退失败');
            }
          }).catch(() => {
            this.$message.info('已取消操作');
          });
        },
        
        // 确认过单
        async handlePassSubmit() {
          try {
            this.detailForm.state = 5; // 已过单
            const result = await toRetnExamine(this.detailForm);
            
            if (result.code === 200) {
              this.$message.success('过单成功');
              this.detailDialogVisible = false;
              this.loadData(); // 刷新表格
            } else {
              this.$message.error(result.message || '过单失败');
            }
          } catch (error) {
            console.error('过单失败:', error);
            this.$message.error('过单失败');
          }
        },
        
        // 拒绝过单
        handleRefusePass() {
          this.$confirm('此操作将回退该条数据状态, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            try {
              this.detailForm.state = 2; // 回退到已提交
              const result = await toRetnExamine(this.detailForm);
              
              if (result.code === 200) {
                this.$message.success('已回退到提交状态');
                this.detailDialogVisible = false;
                this.loadData(); // 刷新表格
              } else {
                this.$message.error(result.message || '回退失败');
              }
            } catch (error) {
              console.error('回退失败:', error);
              this.$message.error('回退失败');
            }
          }).catch(() => {
            this.$message.info('已取消操作');
          });
        },
        
        // 确认冲销
        handleReverse() {
          this.$confirm('此操作将冲销该单据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            try {
              this.detailForm.state = 6; // 已冲销
              const result = await toRetnExamine(this.detailForm);
              
              if (result.code === 200) {
                this.$message.success('冲销成功');
                this.detailDialogVisible = false;
                this.loadData(); // 刷新表格
              } else {
                this.$message.error(result.message || '冲销失败');
              }
            } catch (error) {
              console.error('冲销失败:', error);
              this.$message.error('冲销失败');
            }
          }).catch(() => {
            this.$message.info('已取消操作');
          });
        },
        
        // 关闭详情模态框
        handleDetailClose() {
          this.detailDialogVisible = false;
          this.detailForm = {
            id: '',
            docNum: '',
            supplierId: '',
            supplierName: '',
            state: ''
          };
          this.detailTableData = [];
          this.costTotal = 0;
          this.saleTotal = 0;
        },
        
        // 获取选项数据
        getOptions(optionsKey) {
          switch (optionsKey) {
            case 'supplierOptions':
              return this.supplierOptions;
            default:
              return [];
          }
        },
        
        // 更新表格样式
        updateTableStyle() {
          // 样式更新是响应式的
        },
        
        // 关闭对话框
        handleCloseDialog() {
          this.showColumnSettings = false;
        },
        
        // 保存设置
        handleSaveSettings() {
          this.showColumnSettings = false;
          // 在实际应用中，这里应该将设置保存到本地存储或后端
        }
      }
    }
    </script>
    
    <style lang="less">
    .purchase-history-container {
      height: calc(90vh - 20px);
      display: flex;
      flex-direction: column;
      background-color: #f5f7fa;
      padding: 15px;
      overflow: hidden;
      position: relative;
      
      .page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        
        .page-title {
          font-size: 18px;
          font-weight: bold;
          color: #303133;
          margin: 0;
        }
        
        .header-actions {
          .el-button {
            margin-left: 10px;
          }
        }
      }
      
      .filter-section {
        background: #fff;
        padding: 15px;
        border-radius: 4px;
        margin-bottom: 15px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        
        .el-form-item {
          margin-bottom: 10px;
        }
        
        .more-filters {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid #e6e6e6;
        }
      }
      
      .table-section {
        flex: 1;
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        
        .table-container {
          height: 100%;
          
          &.font-small {
            .el-table {
              font-size: 12px;
            }
          }
          
          &.font-medium {
            .el-table {
              font-size: 14px;
            }
          }
          
          &.font-large {
            .el-table {
              font-size: 16px;
            }
          }
          
          &.row-compact {
            .el-table__row {
              height: 32px;
            }
          }
          
          &.row-normal {
            .el-table__row {
              height: 40px;
            }
          }
          
          &.row-loose {
            .el-table__row {
              height: 48px;
            }
          }
          
          .stateValue {
            border-radius: 4px;
            text-align: center;
            padding: 2px 8px;
            font-size: 12px;
            display: inline-flex;
            align-items: center;
            
            i {
              margin-right: 4px;
            }
            
            &.clickable {
              cursor: pointer;
              transition: all 0.3s;
              
              &:hover {
                opacity: 0.8;
                transform: scale(1.05);
              }
            }
          }
        }
      }
      
      .pagination-section {
        display: flex;
        justify-content: flex-end;
        padding: 10px 0;
      }
      
      .column-settings {
        .setting-item {
          margin-bottom: 20px;
          
          h4 {
            margin-bottom: 10px;
            font-size: 14px;
            color: #606266;
          }
          
          .el-radio-group {
            .el-radio {
              margin-right: 20px;
            }
          }
        }
        
        .setting-hint {
          display: flex;
          align-items: center;
          padding: 10px;
          background-color: #f0f9ff;
          border-radius: 4px;
          color: #409eff;
          font-size: 12px;
          
          i {
            margin-right: 5px;
          }
        }
        
        .column-list {
          max-height: 300px;
          overflow-y: auto;
          
          .el-checkbox-group {
            display: flex;
            flex-direction: column;
            
            .el-checkbox {
              margin-bottom: 10px;
            }
          }
        }
      }
      
      .add-page-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: white;
        z-index: 1000;
        overflow: auto;
      }
      
      // 详情模态框样式
      .detail-dialog {
        .el-dialog__header {
          padding: 10px 20px;
          background-color: #007bb0;
          
          .el-dialog__title {
            color: #fff;
            font-size: 16px;
          }
          
          .el-dialog__headerbtn {
            top: 13px;
            
            .el-dialog__close {
              color: #fff;
            }
          }
        }
        
        .detail-container {
          max-height: 60vh;
          overflow-y: auto;
          
          .form-section {
            margin-bottom: 20px;
            padding: 10px;
            background: #f8f9fa;
            border-radius: 4px;
            
            .el-form-item {
              margin-bottom: 10px;
            }
          }
          
          .detail-table-section {
            .total-section {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding: 10px;
              background: #f5f7fa;
              margin-top: 10px;
              
              span {
                font-size: 14px;
                font-weight: bold;
                margin-right: 10px;
              }
            }
          }
        }
        
        .dialog-footer {
          display: flex;
          justify-content: center;
          padding: 10px 0;
          
          .el-button {
            margin: 0 10px;
          }
        }
      }
      
      // 操作进度样式
      .operation-progress-container {
        .status-messages {
          margin-bottom: 20px;
          
          .status-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 0;
            border-bottom: 1px solid #f0f0f0;
            
            .status-icon {
              font-size: 18px;
            }
          }
        }
        
        .step-messages {
          max-height: 200px;
          overflow-y: auto;
          margin-top: 15px;
          border: 1px solid #e6e6e6;
          border-radius: 4px;
          padding: 10px;
          
          .step-message {
            padding: 5px 0;
            font-size: 12px;
            
            .time {
              color: #909399;
              margin-right: 10px;
            }
            
            &.message-error {
              color: #f56c6c;
            }
            
            &.message-success {
              color: #67c23a;
            }
            
            &.message-info {
              color: #909399;
            }
          }
        }
      }
    }
    
    // 过渡动画
    .el-zoom-in-center-enter-active,
    .el-zoom-in-center-leave-active {
      transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
    }
    
    .el-zoom-in-center-enter,
    .el-zoom-in-center-leave-active {
      opacity: 0;
      transform: scaleX(0);
    }
    
    // Element UI 样式微调
    .el-table {
      .el-table__header-wrapper {
        th {
          background-color: #f5f7fa;
        }
      }
      
      .el-table__body-wrapper {
        overflow-y: auto;
      }
    }
    
    .el-dialog {
      .el-dialog__header {
        border-bottom: 1px solid #e6e6e6;
        padding: 15px 20px 10px;
        
        .el-dialog__title {
          font-size: 16px;
          font-weight: bold;
        }
      }
      
      .el-dialog__body {
        padding: 20px;
      }
    }
    </style>